module.exports = __webpack_public_path__ + "media/assets/community/banner-community-ca1bb0a915743e63b1bb90ae859edc6ebd4a6b00cfda3da0d22b409f2b02e92c.png";